module.exports = __webpack_public_path__ + "assets/img/30.82d71bbb.png";